<template>
  <section
    class="sec sec--quiz reveal"
    id="quiz-match"
    data-ga-section="quiz_match"
  >
    <div class="sec--quiz-inner">
      <div class="spotlight">
        <div class="sl-left">
          <span class="sec-eyebrow">{{ trans.get('landing.quiz.eyebrow') }}</span>
          <h2 class="sec-title">
            {{ trans.get('landing.quiz.title_line1') }}
            <br />
            {{ trans.get('landing.quiz.title_line2_prefix')
            }}<span class="grad">{{ trans.get('landing.quiz.title_line2_grad') }}</span
            ><span class="title-dot">{{ trans.get('landing.quiz.title_line2_dot') }}</span>
          </h2>
          <p class="sec-lede sec-lede--tight">{{ trans.get('landing.quiz.lede') }}</p>

          <div class="pic-list">
            <div
              v-for="feat in features"
              :key="feat.key"
              class="sl-feat"
            >
              <div class="ic">
                <component
                  :is="feat.icon"
                  :size="16"
                />
              </div>
              <div>
                <h4>{{ trans.get(feat.titleKey) }}</h4>
                <p>{{ trans.get(feat.textKey) }}</p>
              </div>
            </div>
          </div>

          <button
            class="btn-primary btn-primary--inline"
            type="button"
            data-cta-location="quiz_match"
            @click="openSignup"
          >
            {{ trans.get('landing.quiz.cta') }}
          </button>
        </div>

        <div class="sl-right">
          <div class="sl-card">
            <div class="qnum">{{ trans.get('landing.quiz.card_qnum') }}</div>
            <p class="qtxt">{{ trans.get('landing.quiz.card_q') }}</p>
            <div class="qopts">
              <div
                v-for="opt in cardOpts"
                :key="opt.key"
                class="qopt"
                :class="{ picked: opt.picked }"
              >
                {{ trans.get(opt.labelKey) }}<span class="pct">{{ trans.get(opt.pctKey) }}</span>
              </div>
            </div>
            <div class="qfooter">
              <div class="av-mini"></div>
              <span>{{ trans.get('landing.quiz.card_footer') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import IconCheckCircle from '../icons/IconCheckCircle.vue';
import IconBolt from '../icons/IconBolt.vue';
import IconChat from '../icons/IconChat.vue';

const FEATURE_ICONS = {
  feat1: IconCheckCircle,
  feat2: IconBolt,
  feat3: IconChat,
};

export default {
  name: 'QuizMatchSection',
  data() {
    return {
      features: [
        {
          key: 'feat1',
          icon: FEATURE_ICONS.feat1,
          titleKey: 'landing.quiz.feat1_title',
          textKey: 'landing.quiz.feat1_text',
        },
        {
          key: 'feat2',
          icon: FEATURE_ICONS.feat2,
          titleKey: 'landing.quiz.feat2_title',
          textKey: 'landing.quiz.feat2_text',
        },
        {
          key: 'feat3',
          icon: FEATURE_ICONS.feat3,
          titleKey: 'landing.quiz.feat3_title',
          textKey: 'landing.quiz.feat3_text',
        },
      ],
      cardOpts: [
        {
          key: 'opt1',
          labelKey: 'landing.quiz.opt1_label',
          pctKey: 'landing.quiz.opt1_pct',
          picked: false,
        },
        {
          key: 'opt2',
          labelKey: 'landing.quiz.opt2_label',
          pctKey: 'landing.quiz.opt2_pct',
          picked: true,
        },
        {
          key: 'opt3',
          labelKey: 'landing.quiz.opt3_label',
          pctKey: 'landing.quiz.opt3_pct',
          picked: false,
        },
      ],
    };
  },
  methods: {
    openSignup() {
      this.$eventHub.$emit('viluu-landing:open-signup', {
        mode: 'register',
        cta_location: 'quiz_match',
      });
    },
  },
};
</script>
<style scoped lang="scss">
.spotlight {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 80px;
  align-items: center;
}

.sl-left .pic-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 32px 0 36px;
  max-width: 520px;
}

.sl-feat {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.sl-feat .ic {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  background: linear-gradient(135deg, var(--coral), var(--pink));
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: #fff;
}

.sl-feat h4 {
  font-family: var(--display);
  font-size: 17px;
  margin: 2px 0 4px;
  font-weight: 700;
}

.sl-feat p {
  font-size: 14px;
  color: var(--ink-dim);
  margin: 0;
  line-height: 1.5;
}

.sl-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 32px;
  padding: 36px;
  box-shadow: 0 30px 70px -30px rgba(198, 62, 124, 0.3);
  transform: rotate(-2deg);
  transition: transform 0.4s ease;
}

.sl-card:hover {
  transform: rotate(0deg);
}

.sl-card .qnum {
  font-size: 11px;
  letter-spacing: 0.1em;
  color: var(--ink-mute);
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.sl-card .qtxt {
  font-family: var(--display);
  font-size: 24px;
  line-height: 1.25;
  font-weight: 700;
  margin: 0 0 24px;
  letter-spacing: -0.01em;
}

.sl-card .qopts {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sl-card .qopt {
  padding: 14px 18px;
  background: #faf5f1;
  border: 1.5px solid var(--line);
  border-radius: 16px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sl-card .qopt:hover {
  border-color: var(--pink);
}

.sl-card .qopt.picked {
  background: linear-gradient(135deg, var(--coral), var(--pink));
  color: #fff;
  border-color: transparent;
  box-shadow: 0 12px 24px -10px rgba(198, 62, 124, 0.5);
}

.sl-card .qopt .pct {
  font-size: 11px;
  opacity: 0.7;
  font-weight: 500;
}

.sl-card .qfooter {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px dashed var(--line);
  font-size: 12px;
  color: var(--ink-dim);
}

.sl-card .qfooter .av-mini {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffd2c2, #ff8a9e);
  border: 2px solid #fff;
  box-shadow: 0 4px 10px -4px rgba(198, 62, 124, 0.4);
}

.sec.sec--quiz {
  background: linear-gradient(180deg, transparent 0%, #fff5ec 50%, transparent 100%);
  max-width: none;
  padding-left: 0;
  padding-right: 0;
}

.sec--quiz-inner {
  max-width: 1480px;
  margin: 0 auto;
  padding: 0 56px;
}

.sl-right {
  display: grid;
  place-items: center;
}

@media (max-width: 1100px) {
  .spotlight {
    grid-template-columns: 1fr;
    gap: 50px;
  }
}
</style>
